import { ClientRequestAnswerActivity, ClientRequestDocumentActivity, ClientRequestGroupType } from '@aiwyn/api';
import { TypedIdentity } from '@aiwyn/common/client-requests';
import { LoadableStatus } from '@aiwyn/shared';
import { merge } from 'ts-deepmerge';
import { AllDeliverables, AllRequestItemFilters, ClientRequestFilters } from '../models';

export const CLIENT_REQUEST_FILTERS_KEY = 'clientRequestFilters';
export const CLIENT_REQUEST_ITEM_FILTERS_KEY = 'clientRequestItemFilters';

export interface ClientRequestsStateModel {
  status: LoadableStatus;
  filters: ClientRequestFilters;
  selectedGroupIdentity?: TypedIdentity<ClientRequestGroupType>;
  selectedRequestId?: number;
  stagedFileJobIds: string[];
  newlyUpdatedFiles: string[];
  hasSelectedRequestBeenModified: boolean;
  selectedRequestItemId?: number;
  // only used when a deliverable ID is present as a query param (cleared once the deliverable is focused or found to be invalid)
  focusedDeliverableId?: number | AllDeliverables;
  answersActivity: ClientRequestAnswerActivity[];
  documentActivity: ClientRequestDocumentActivity[];
  notApplicableItems: { [clientRequestId: number]: Array<{ itemId: number; note: string | null }> };
  requestItemFilters?: AllRequestItemFilters;
  /**
   * Used in secure links to restrict the full client request to a list of individual items.
   */
  restrictedRequestItemsIds?: number[];
}

export const DEFAULT_CLIENT_REQUESTS_STATE: ClientRequestsStateModel = {
  status: LoadableStatus.DEFAULT,
  stagedFileJobIds: [],
  newlyUpdatedFiles: [],
  hasSelectedRequestBeenModified: false,
  filters: {},
  answersActivity: [],
  documentActivity: [],
  notApplicableItems: {},
};

export class ClientRequestsStateModelMock {
  protected _model: ClientRequestsStateModel = {
    status: LoadableStatus.LOADED,
    filters: {},
    stagedFileJobIds: [],
    newlyUpdatedFiles: [],
    hasSelectedRequestBeenModified: false,
    answersActivity: [],
    documentActivity: [],
    notApplicableItems: {},
  };

  constructor(overrides: Partial<ClientRequestsStateModel> = {}) {
    this._model = merge.withOptions(
      { mergeArrays: false },
      this._model,
      overrides,
    ) as unknown as ClientRequestsStateModel;
  }

  public model(): ClientRequestsStateModel {
    return this._model;
  }
}

export interface ClientRequestSubmitFileData {
  jobId: string;
  documentIds: number[]; // pass empty array if undefined
  skipCategorization?: boolean;
}
